import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, Select } from "@mui/material";
import { useIsEligibilityReadOnly } from "app/frontend/components/contact/useIsEligibilityReadOnly";
import { useAddRow } from "app/frontend/components/eligibility/accordions/project_size/hooks/useAddRow";
import ProjectSizeAccordionAddPlugButton from "app/frontend/components/eligibility/accordions/project_size/ProjectSizeAccordionAddPlugButton";
import ProjectSizeAccordionRow from "app/frontend/components/eligibility/accordions/project_size/ProjectSizeAccordionRow";
import { IProjectSizeFormData } from "app/frontend/components/eligibility/accordions/project_size/types";
import { useFormContext } from "app/frontend/contexts/useFormContext";
import { useIsMHD } from "app/frontend/hooks/useIsMHD";
import { noop } from "chart.js/helpers";

const ProjectSizeAccordionContent: React.FC = () => {
    const { data, setData } = useFormContext<IProjectSizeFormData>();
    const readOnly = useIsEligibilityReadOnly();
    const isMHD = useIsMHD();

    const addRow = useAddRow();

    return (
        <Grid container spacing={2} sx={{ my: 4 }}>
            {data.plugs.map((_, i, array) => (
                <ProjectSizeAccordionRow
                    key={`project-size-row-${i}`}
                    index={i}
                    isLastItem={i + 1 === array.length}
                    disabled={readOnly || data.isProjectSizeUnknown}
                />
            ))}

            {isMHD && (
                <Grid size={12}>
                    <Grid container spacing={2} sx={{ flexDirection: { xs: "column-reverse", md: "row" } }}>
                        <Grid size={{ xs: 12, md: 5 }}>
                            <FormControlLabel
                                sx={{ fontSize: "14px", fontWeight: 400 }}
                                label={"I don't know yet"}
                                control={
                                    <Checkbox
                                        name={"isProjectSizeUnknown"}
                                        checked={data.isProjectSizeUnknown}
                                        onChange={(e) => setData("isProjectSizeUnknown", e.currentTarget.checked)}
                                        disabled={readOnly}
                                    />
                                }
                            />
                        </Grid>
                        <Grid size={3} sx={{ display: { xs: "none", md: "initial" } }}>
                            <FormControl disabled fullWidth sx={{ visibility: "hidden" }}>
                                <InputLabel id={"placholder-not-visible-label"}>Placeholder</InputLabel>
                                <Select
                                    aria-disabled
                                    aria-hidden
                                    disabled
                                    id="placholder-not-visible"
                                    name={"placeholder"}
                                    required={false}
                                    label={"Placeholder"}
                                    labelId={"placholder-not-visible-label"}
                                    inputProps={{
                                        id: "placholder-not-visible",
                                        "aria-labelledby": "placholder-not-visible-label",
                                    }}
                                    value={""}
                                    onChange={noop}
                                ></Select>
                            </FormControl>
                        </Grid>
                        {!readOnly && (
                            <Grid size={4} sx={{ textAlign: "right", display: { xs: "none", md: "initial" } }}>
                                <ProjectSizeAccordionAddPlugButton addRow={addRow} />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

export default ProjectSizeAccordionContent;
